/* eslint-disable vue/require-v-for-key */
<template>
    <div class="steamerTicket">
        <div class="steamerTicket-back" :style="{backgroundImage:'url('+bkimg+')'}"></div>
        <div class="steamerTicket-content">
            <div class="steamerTicket-content-left">
                <div class="navigate pointer">
                    <span :class='{"lastnav":index==navigate.length-1}' v-for='(nav,index) in navigate' :key='index' @click='goto(index)'>{{nav}}<span class='lastnav' v-show='index != navigate.length-1'>></span></span>
                </div>
                <div class="content-left-tabtitle" style="font-weight:bold;margin:28px 0;font-size:24px;">探险船</div>
                <div class="content-left-tab">
                    <div :class='{"content-left-tab-item":true,"active-item":item.active}' v-for="(item,index) in tabs" :key="index" @click='itemchange(index)'>{{item.name}}</div>
                    <div class="content-left-tab-btn" @click ='book'>我要预约</div>
                </div>
                <div class="content-left-contents l0">
                    <!-- <div class="content-left-content">
                        <div><img class="content-left-content-title" src="../assets/steamerTicket-tab1.png" alt=""></div>

                        <div class="content-left-content-list">
                            <div class="content-left-content-more"><span>更多</span><img class='more' src="../static/images/more.png" alt="" gotoall='gtoall'></div>
                            <div class="content-item" v-for='(item,index) in linelists' :key='index'>
                                <img class="content-item-img" :src="item.thumbnail" alt="">
                                <div class="content-item-word" >
                                    <div style="color:#ffa51f;font-style:oblique;margin-bottom:5px;font-size:12px;">{{item.classes}}</div>
                                    <div style="font-weight:bold;margin-bottom:5px;font-size:16px;">{{item.title}}</div>
                                    <div style="color:#7a7a7a;font-size:12px;">出行时间：{{item.time}}</div>
                                </div>
                                <div class="content-item-tag">
                                    <div class="content-item-tag-item" v-for='(btag,index) in item.bottomTags' :key='index'>{{btag}}</div>
                                </div>
                                <div class="content-item-feel">
                                    <span>{{item.topTags[0]}}</span> | <span>{{item.topTags[1]}}</span>
                                </div>
                                <div class="content-item-hot">主推线路</div>
                            </div>

                        </div>
                    </div> -->
                    <div class="content-left-content l1">
                        <div><img class="content-left-content-title" src="../assets/steamerTicket-tab3.png" alt=""></div>
                        <div class="content-left-content-introduce">
                            <div class="content-detail-word">{{detail.detail}}</div>
                        </div>
                    </div>
                    <div class="content-left-content l2">
                        <div><img class="content-left-content-title" src="../assets/steamerTicket-tab5.png" alt=""></div>
                        <div class="content-left-content-introduce detaila" v-html='detail.introduction'>
                        </div>
                    </div>
                    <div class="content-left-content l3">
                        <div><img class="content-left-content-title" src="../assets/steamerTicket-tab4.png" alt=""></div>
                        <div class="content-left-content-introduce detaila" v-html='detail.deck'>
                        </div>
                    </div>
                    <div class="content-left-content l4">
                        <div><img class="content-left-content-title" src="../assets/steamerTicket-tab2.png" alt=""></div>
                        <div class="content-left-content-table detaila" v-html='detail.price'>
                            <!-- <div class="content-left-content-table-header">
                                <div class="table-header-item" v-for='item in tableHeader' :key="item.index">{{item.name}}</div>
                            </div>
                            <div class="content-left-content-table-body">
                                <div class="table-body-item"><div><p style="font-size:14px;">马来西亚</p><p style="font-size:12px;">2011-11-11</p><p style="font-size:14px;">查看行程</p></div></div>
                                <div class="table-body-item" v-for='item in tableHeader' :key="item.index"><div><p style="font-size:16px;">$1231</p><p style="font-size:14px;">充足</p></div></div>
                            </div> -->
                        </div>
                    </div>
                </div>
            </div>
            <div class="steamerTicket-content-right">
                <!-- <div class="steamerTicket-content-right-route">
                    <div class="content-right-route-title">相关路线</div>
                    <Lists2 :sidelists="hotlists"></Lists2>

                </div> -->
                <div class="steamerTicket-content-right-route">
                    <div class="content-right-route-title">往期回顾</div>
                    <Lists2 :sidelists="plists"></Lists2>
                </div>
            </div>
        </div>
        <div class="steamerTicket-like">
            <div class="steamerTicket-like-title">
                <div class="steamerTicket-like-title-left" style="font-size:24px;font-weight:bold;7f8286">猜你喜欢</div>
                <div class="steamerTicket-like-title-right" style="font-size:14px;color:#7f8286;" @click='change'>换一批</div>
            </div>
            <div class="content-left-content-list">
                <Lists :lists="hotlists"></Lists>
            </div>
        </div>
        <Book v-show='bookshow'></Book>
    </div>
</template>

<script>
import bk from '@/static/images/b3.jpg'
import Lists2 from '@/components/ListsContent2.vue'
import Lists from '@/components/ListsContent.vue'
import Book from '@/components/book/book.vue'
import {shipdetail} from '@/api/ship.js'
import {getthemelist} from '@/api/theme.js'
import {querycontent} from '@/api/content.js'
import {sliceDate} from '@/utils/index.js'
import {reviewlist} from '@/api/past.js'
export default {
  data () {
    return {
      bkimg: bk,
      navigate: ['首页', '船票预定'],
      activeName: 'second',
      tabs: [
        // {'name': '航期', 'index': '0', active: true},
        { 'name': '游轮简介', 'index': '2', active: true },
        { 'name': '船舱介绍', 'index': '4', active: false },
        { 'name': '甲板结构', 'index': '3', active: false },
        { 'name': '票价', 'index': '1', active: false }
      ],
      tableHeader: [{'name': '三人套房', 'index': 0}, {'name': '三人套房', 'index': 0}, {'name': '三人套房', 'index': 1}, {'name': '主甲板套房', 'index': 2}, {'name': '经典套房', 'index': 3}, {'name': '高级套房', 'index': 4}, {'name': '豪华套房', 'index': 5}, {'name': '奢华套房', 'index': 6}],
      lists: [
        {
          classes: '[极地探险-北极路线]',
          name: '南极长城马拉松',
          address: '北京/重庆集合',
          time: '2019-01-01至2019-01-13',
          tag: ['特别刺激', '完美体验'],
          imgPath: require('../assets/img/hot-router-img.png'),
          userTag: ['企鹅/海豹', '网红拍摄地点', '家庭亲子游'],
          active: true
        },
        {
          classes: '[极地探险-北极路线]',
          name: '南极长城马拉松',
          address: '北京/重庆集合',
          time: '2019-01-01至2019-01-13',
          tag: ['特别刺激', '完美体验'],
          userTag: ['企鹅/海豹', '网红拍摄地点', '家庭亲子游'],
          imgPath: require('../assets/img/hot-router-img.png'),
          active: false
        },
        {
          classes: '[极地探险-北极路线]',
          name: '南极长城马拉松',
          address: '北京/重庆集合',
          time: '2019-01-01至2019-01-13',
          tag: ['特别刺激', '完美体验'],
          userTag: ['企鹅/海豹', '网红拍摄地点', '家庭亲子游'],
          imgPath: require('../assets/img/hot-router-img.png'),
          active: false,
          bgimg: ''
        }
      ],
      sidelists: [
        {
          name: '北极路线1',
          introduce: '北极路线北极路线北极路线',
          money: 12345,
          num: 197,
          imgPath: require('../assets/steamerTicket-route.png'),
          active: true
        },
        {
          name: '北极路线2',
          introduce: '北极路线北极路线北极路线',
          money: 12345,
          num: 197,
          imgPath: require('../assets/steamerTicket-route.png'),
          active: false
        }
      ],
      bookshow: false,
      showindex: '',
      detail: {
        price: ''
      },
      hotlists: [],
      hotquery: {
        page: 1,
        limit: 3,
        ishot: true
      },
      hottotal: 0,
      themes: [],
      plists: [],
      pquerylist: {
        page: 1,
        limit: 2,
        themeid: undefined,
        ishot: undefined
      },
      linelists: []
    }
  },
  components: {
    Lists,
    Lists2,
    Book
  },
  methods: {
    goto (index) {
      if (index === 0) {
        this.$router.push({path: '/index'})
      } else if (index === 1) {
        this.$router.go(-1)
      }
    },
    handleClick (tab, event) {
      console.log(tab, event)
    },
    // 我要预定
    book () {
      this.bookshow = true
    },
    cancel () {
      this.bookshow = false
    },
    // 切换导航栏
    itemchange (index) {
      this.tabfalse()
      this.tabs[index].active = true
      var el = document.getElementsByClassName(`l${index + 1}`)[0]
      if (this.showIndex === index) {
        this.showIndex = null
      } else {
        this.showIndex = index
      }
      this.$nextTick(function () {
        window.scrollTo({'behavior': 'smooth', 'top': el.offsetTop})
      })
    },
    // 导航栏active false
    tabfalse () {
      for (let i = 0; i < this.tabs.length; i++) {
        this.tabs[i].active = false
      }
    },
    getdetail (id) {
      shipdetail({id}).then(res => {
        this.detail = res.data.data
        querycontent({limit: 3, menuId: res.data.data.menuId}).then(res => {
          let items = res.data.data.items
          for (let i = 0; i < items.length; i++) {
            items[i].time = `${sliceDate(items[i].travelBeginTime)}至${sliceDate(items[i].travelEndTime)}`
            items[i].classes = this.themes[items[i].themeId]
          }
          this.linelists = items
        })
      })
    },
    getthemelist () {
      getthemelist({limit: 1000}).then(res => {
        if (res.data.errno === 0) {
          let themes = res.data.data.items
          themes.forEach(element => {
            this.themes[element.id] = element.tname
          })
          this.gethotlist()
        } else {
          this.waringword = res.data.errmsg
          this.wraingshow = true
          setTimeout(() => { this.wraingshow = false }, 1000)
        }
      })
    },
    gethotlist () {
      querycontent(this.hotquery).then(res => {
        let items = res.data.data.items
        for (let i = 0; i < items.length; i++) {
          items[i].time = `${sliceDate(items[i].travelBeginTime)}至${sliceDate(items[i].travelEndTime)}`
          items[i].classes = this.themes[items[i].themeId]
          items[i].active = false
        }
        items[0].active = true
        this.hotlists = items
        this.hottotal = res.data.data.total
      })
    },
    change () {
      if (this.hottotal <= this.hotquery.page * 3) {
        this.hotquery.page = 1
      } else {
        this.hotquery.page += 1
      }
      this.gethotlist()
    },
    geptlist () {
      reviewlist(this.pquerylist).then(res => {
        this.plists = res.data.data.items
      })
    },
    gtoall () {
      this.$router.push({path: '/allRouterLists'})
    }
  },
  created () {
    if (this.$route.query.img) {
      this.bkimg = this.$route.query.img
      this.navigate.push(this.$route.query.name)
    }
    if (this.$route.query.id) {
      this.getdetail(this.$route.query.id)
    }
    this.getthemelist()
    this.geptlist()
  }
}
</script>

<style scoped>
  .navigate{
    height:3.75rem;
    text-align:left;
    color:#0080cc;
    font-size:.875rem;
    line-height:3.75rem;
    border-bottom:1px solid #dae1e6;
  }
  .pointer{
    cursor: pointer;
  }
  .navigate span{
    margin-left:.3125rem;
  }
  .lastnav{
    color:#60676d;
  }
.steamerTicket{
    width:100%;
    height:100%;
    background:#eee;
    position: relative;
}
.steamerTicket-back{
    width:100%;
    height:670px;
    background-position: center center;
    background-repeat: no-repeat;
    background-size: cover;
}
.steamerTicket-content{
    width:1280px;
    margin:0 auto;
    background:#fff;
    transform:translateY(-196px);
    padding:0px 24px;
    box-sizing: border-box;
    display:flex;
}
.steamerTicket-content-left{
    flex:1;
    padding-right:24px;
    box-sizing:border-box;
}
.content-left-top{
    height:58px;
    line-height:58px;
    border-bottom:1px solid #eee;
}
.content-left-tab{
    background: #eee;
    display: flex;
    height:44px;
    line-height:44px;
    font-size:14px;
    position: relative;
    margin-bottom:30px;
}
.content-left-tab-item{
   flex:0 0 100px;
   text-align: center;
}
.active-item{
     border-bottom:2px solid #0080cc;
     background:rgba(232,240,245,1);
}
.content-left-tab-btn{
    height:50px;
    line-height:50px;
    padding:0 24px;
    font-size:16px;
    background: #ff6600;
    color:#fff;
    position: absolute;
    right:0;
    bottom:0;
    background:url('../static/images/book.png')
}
.content-left-content{
    margin-bottom:28px;
}
.content-left-content-title{
    width:136px;
    height:42px;
    margin-bottom:20px;
}
.content-left-content-more{
    color:#c0c6c9;
    font-size:14px;
    position: absolute;
    right:0;
    top: -30px;
    display:flex;
    align-items: center;
}
.more{
    margin-left:6px;
}
.content-left-content-list{
    display:flex;
    justify-content: space-between;
    position: relative;
}
.content-item{
    flex:0 0 32%;
    /* height:100px; */
    /* margin-right:10px; */
    /* margin-bottom:10px; */
    border:1px solid #eee;
    position: relative;
}
.content-item-img{
    width:100%;
    height:196px;
}
.content-item-word{
    width:100%;
    box-sizing: border-box;
    padding:10px;
}
.content-item-tag{
    display:flex;
    flex-wrap:wrap;
    box-sizing: border-box;
    padding:10px;
    padding-top:0px;
}
.content-item-tag-item{
    padding:5px;
    border:1px solid #039aff;
    color:#039aff;
    margin-right:10px;
    margin-bottom:5px;
    font-size:12px;
    font-style:oblique;
}
.content-item-feel{
    position: absolute;
    left:0;
    top:0;
    padding:10px 16px;
    background:black;
    opacity: 0.4;
    color:#fff;
    font-size:12px;
}
.content-item-hot{
    background:#ffa51f;
    padding:8px 12px;
    color:#fff;
    position: absolute;
    left:0;
    top:164px;
    font-size:12px;
}
.content-left-content-table{
    border-top:1px solid #e8e8e8;
    border-left:1px solid #e8e8e8;
    font-size:10px;
}
.content-left-content-table-header{
    display:flex;
    height:46px;
    line-height:46px;
    background:#f3f3f3;
    color:#8c8c8c;
    font-size:14px;
}
.table-header-item{
    flex:1;
    text-align:center;
    border-right:1px solid #e8e8e8;
    border-bottom:1px solid #e8e8e8;
}
.content-left-content-table-body{
    display:flex;
    align-items: center;
    justify-content: center;
    height:90px;
    color:#8c8c8c;
}
.table-body-item{
    flex:1;
    text-align:center;
    display: flex;
    align-items: center;
    justify-content: center;
    border-right:1px solid #eee;
    border-bottom:1px solid #eee;
    /* height:60px; */
    height:100%;
}
.content-left-content-introduce{
    margin-top:8px;
    line-height: 1.5;
}

.content-left-content-last{
    width:100%;
    margin-top:28px;
    display:flex;
    position: relative;
}
.content-left-content-last-img{
    width:560px;
    height:370px;
    transform: translate(10px,-17px);
    /* transform: translateY(-17px); */
}
.content-left-content-last-word{
    color:#fff;
    padding:30px 16px 30px 26px;
}
.content-left-content-last-btn{
    display:flex;
    position: absolute;
    right:1px;
    bottom:1px;
}
.content-last-btn{
    width:36px;
    height:28px;
    line-height: 30px;
    background: #dee4e7;
    margin-left:2px;
    text-align: center;
    color:#afb6ba;
}
.steamerTicket-content-right{
    flex:0 0 334px;
    border-left:1px solid #eee;
    padding:0 24px;
    box-sizing: border-box;
}
.steamerTicket-content-right-route{

}
.content-right-route-title{
    /* height:56px;
    line-height: 56px; */
    padding-top:20px;
    font-size:18px;
    font-weight:bold;
}
/* .content-right-route-list{
    display:flex;
   padding:20px 0;
   border-bottom:1px solid #f4f4f4;
}
.content-right-route-list-left{
    width:140px;
    height:90px;
    margin-right:10px;
}
.content-right-route-list-left img{
    width:100%;
    height:100%;
}
.content-right-route-list-right{
    flex:1;
    display:flex;
    flex-direction: column;
    justify-content: space-between;
    width:140px;
}
.content-right-route-list-right-second{
    font-size:16px;
    color:#9ca5ab;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    margin-bottom:15px;
}
.content-right-route-list-right-third{
    margin-bottom:0;
    display:flex;
    align-items: center;
    justify-content: space-between;
} */
.steamerTicket-like{
    width: 1280px;
    margin: 0 auto;
    /* margin-top:24px; */
    transform: translateY(-172px);
    background:#fff;
    padding:24px;
    box-sizing: border-box;
}
.steamerTicket-like-title{
    margin-bottom:20px;
    display:flex;
    justify-content: space-between;
    align-items: center;
}
.fl{
    float:left;
}
.fr{
    float:right;
}
.content-detail-word{
    font-size:14px;
    font-weight:300;
    color:rgba(88,88,88,1);
    text-indent:2em; padding:0px; margin:0px;
}
</style>



// WEBPACK FOOTER //
// src/views/steamerTicket.vue